import { LOAD_START, LOAD_SUCCESS, LOAD_FAILURE } from './actions.js';

const initialState = {
  loading: true,
  errors: null,
  data: null
};

export default (state = {}, action) => {
  const newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case LOAD_START:
      newState.loading = true;
      newState.errors = null;
      newState.data = null;
      break;
    case LOAD_FAILURE:
      newState.loading = false;
      newState.errors = action.payload;
      newState.data = null;
      break;
    case LOAD_SUCCESS:
      newState.loading = false;
      newState.errors = null;
      newState.data = action.payload.data;
      break;
    default:
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/dashboard/reducer.js